<template>
    <div class="container">
        <top></top>

        <list></list>

        <div class="major">
            <div class="content">
                <img src="../../assets/img-T115/T115.jpg" alt="">
            </div>

            <div class="main">
                <div class="Product-information">
                    <h2>
                        <span v-t="'Product_information'"></span>
                    </h2>
                    <div class="Product-information-content">
                        <div class="Product-information-left">
                            <div class="Product-information-left-top">
                                <img src="../../assets/img-T115/588x310-01.png" alt="" class="block" v-show="block=='A'">
                                <img src="../../assets/img-T115/588x310-02.png" alt="" class="block" v-show="block=='B'">
                                <img src="../../assets/img-T115/588x310-03.png" alt="" class="block" v-show="block=='C'">
                                <img src="../../assets/img-T115/588x310-04.png" alt="" class="block" v-show="block=='D'">
                            </div>
                            <div class="Product-information-left-bottom">
                                <ul>
                                    <li @click="up('A')" v-bind:class="{'active':(active=='A')}"><img src="../../assets/img-T115/135x90-01.png" alt=""></li>
                                    <li @click="up('B')" v-bind:class="{'active':(active=='B')}"><img src="../../assets/img-T115/135x90-02.png" alt=""></li>
                                    <li @click="up('C')" v-bind:class="{'active':(active=='C')}"><img src="../../assets/img-T115/135x90-03.png" alt=""></li>
                                    <li @click="up('D')" v-bind:class="{'active':(active=='D')}"><img src="../../assets/img-T115/135x90-04.png" alt=""></li>
                                </ul>
                            </div>
                        </div>
                        <div class="Product-information-right">
                            <h3><span>T115</span></h3>
                            <p v-t="'t115_p1'">
                            </p>
                        </div>
                    </div>
                </div>

                <div class="Specifications">
                    <h2>
                        <span v-t="'Parameter_specification'"></span>
                    </h2>
                    <div class="Specifications-main">
                        <table border="1px" cellspacing="0" cellpadding="0">
                            <tr>
                                <th v-t="'img'"></th>
                                <th v-t="'model'"></th>
                                <th v-t="'Interface'"></th>
                                <th v-t="'size'"></th>
                                <th v-t="'Introduction_features'"></th>
                            </tr>
                            <tr>
                                <td>
                                    <img src="../../assets/img-T115/160x130.png" alt="">
                                </td>
                                <td>
                                    <h4>T115</h4>
                                    <span></span>
                                </td>
                                <td>
                                    <p v-t="'t115_Interface_p1'"></p>
                                </td>
                                <td>
                                    <p>96.0 x 60.0 x 15.0</p>
                                </td>
                                <td>
                                    <p v-t="'t115_p_word'"></p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div class="Detailed-illustration">
                    <h2>
                        <span v-t="'Detailed_illustration'"></span>
                    </h2>
                    <div class="Detailed-illustration-main">
                        <img src="../../assets/img-T115/01.jpg" alt="">
                        <img src="../../assets/img-T115/02.jpg" alt="">
                        <img src="../../assets/img-T115/03.jpg" alt="">
                        <img src="../../assets/img-T115/04.jpg" alt="">
                        <img src="../../assets/img-T115/05.jpg" alt="">
                        <img src="../../assets/img-T115/06.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>

        <side></side>

        <bottom></bottom>
    </div>
</template>

<script>
    import top from "../../components/common/Head";
    import list from "../../components/common/Nav";
    import side from "../../components/common/Sidebar";
    import bottom from "../../components/common/Foot";

    export default {
        name: "T115",
        components: {
            top,
            list,
            side,
            bottom,
        },
        data(){
            return{
                active: 'A',
                block: 'A',
            }
        },
        methods:{
            up(show) {
                this.active = show;
                this.block = show;
            },
        }
    }
</script>

<style scoped>
    .content img{
        width: 100%;
        height: 100%;
    }
    .Product-information{
        width: 1000px;
        display: flex;
        padding: 30px 0;
        flex-direction: column;
    }
    .Product-information h2{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Product-information h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .Product-information-content{
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }
    .Product-information-left{
        display: flex;
        flex-direction: column;
        width: 600px;
    }
    .Product-information-left-top{
        width: 100%;
        height: 310px;
    }
    .Product-information-left-top img{
        width: 100%;
        height: 100%;
    }
    .Product-information-left-bottom{
        margin-top: 15px;
    }
    .Product-information-left-bottom ul{
        display: flex;
        justify-content: space-between;
        margin: 0;
        padding: 0;
    }
    .Product-information-left-bottom ul li{
        width: 135px;
        height: 90px;
        border: 1px solid silver;
    }
    .Product-information-left-bottom ul .active{
        border: 1px solid blue;
    }
    .Product-information-left-bottom ul li img{
        width: 135px;
        height: 90px;
        cursor: pointer;
        display: block;
    }
    .Product-information-right{
        width: 400px;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
    }
    .Product-information-right h3{
        text-align: left;
        font-size: 25px;
        padding-left: 20px;
    }
    .Product-information-right p{
        font-size: 18px;
        padding: 0 20px;
        text-align: left;
        margin-top: 0;
        word-break: break-all;
        word-wrap: break-word;
    }
    .Specifications{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
    }
    .Specifications h2{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Specifications h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .Specifications-main{
        width: 1000px;
        margin: 30px auto 0;
    }
    .Specifications-main table{
        border: 1px solid #ddd;
        width: 100%;
    }
    .Specifications-main table tr{
        text-align: center;
    }
    .Specifications-main table tr:first-child{
        background-color: #f9f9f9;
    }
    .Specifications-main table tr th{
        padding: .7rem;
        line-height: 1.6;
        border: 1px solid #ddd;
        font-size: 18px;
    }
    .Specifications-main table tr td{
        padding: 10px;
        width: 20%;
        border: 1px solid #ddd;
    }
    .Specifications-main table tr td img{
        width: 160px;
        height: 130px;
    }
    .Detailed-illustration{
        width: 1000px;
        display: flex;
        padding: 30px 0;
        flex-direction: column;
    }
    .Detailed-illustration h2{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Detailed-illustration h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .Detailed-illustration-main{
        margin: 30px auto 0;
    }
    .Detailed-illustration-main img{
        width: 100%;
        height: 650px;
        display: block;
    }
</style>
